<template>
  <div class="Site IndexBox" style="padding-top:0">
    <div class="ScrollBox">
      <div class="box-bg">
        <van-nav-bar
          :border="false"
          :title="$docTitle"
          style="background:transparent"
        >
        </van-nav-bar>
        <van-swipe v-if="InitData.MerchantbannerList.length" :autoplay="3000" indicator-color="#fff" style="height: 8.5rem;margin: 10px 16px;border-radius: 10px;z-index:3">
          <van-swipe-item v-for="(item,index) in InitData.MerchantbannerList" :key="index" @click="openUrl(item)">
            <img :src="InitData.setting.up_url+item.img_path" width="100%" height="100%">
          </van-swipe-item>
        </van-swipe>
        <div v-if="InitData.MerchantbannerList.length" class="box-shadow"></div>
        <div style="margin: 10px 16px;">
          <a v-for="item,index in InitData.zonebannerList" :key="'activity'+index" class="promote" href="javascript:;" @click="openUrl(item)">
            <img :src="`${InitData.setting.up_url}${item.img_path}`" width="100%" style="display: block;">
          </a>
        </div>
        <div class="user-grade">
          <div class="bg">
            <div class="left">
              {{gradeInfo.name}}
              <p>{{$t('Video[0][1]')}}</p>
            </div>
            <div v-if="UserInfo" class="right">
              <van-button v-if="InitData.setting.is_share==1&&gradeInfo.grade!=1" color="var(--button-main)" plain round size="small" style="border:0;padding:0 15px;margin-bottom: 10px" @click="$refs.shareDom.showSheet=true,shareType='vip',shareDan='',getShareOptions('vip')">{{$t('Share[6]')}}({{$t('Share[13]')}}{{InitData.currency}}{{vipShare.all_reward}})</van-button>
              <van-button color="var(--button-main)" plain round size="small" style="border:0;padding:0 15px;" @click="openVip">{{$t('Video[1]')}}</van-button>
            </div>
          </div>
          <div class="line"></div>
        </div>
      </div>
      <van-cell-group v-if="UserInfo" :border="false">
        <template #title>
          {{$t('Video[2][0]')}}
          <div v-if="InitData.setting.is_online==1" class="online-user">
            {{$t('Video[9]')}}: {{onlineNum}}
          </div>
        </template>
        <van-cell class="income" :label="`${$t('Video[2][1]')} ${InitData.currency}${$Util.MoneyFormat(gradeInfo.commission)}`">
          <template #title>
            {{$Util.MoneyFormat(StatisticalData.today_earnings)}}<small>{{InitData.currency}}</small>
          </template>
          <template #extra>
            <van-button color="var(--button-main)" plain round size="mini" to="user/wallet">{{$t('Video[2][2]')}}</van-button>
          </template>
        </van-cell>
      </van-cell-group>
      <div v-if="taskInfo" class="task-item">
        <div class="info">
          <div class="progress">
            <div class="flex">
              {{$t('Video[3][0]')}}
              <b>{{StatisticalData.day_number}}</b>
            </div>
            <van-progress :percentage="StatisticalData.my_day_number?parseInt(StatisticalData.day_number/StatisticalData.my_day_number*100):0" color="var(--background-linear)" track-color="#d1d1d1" stroke-width="6" :show-pivot="false" />
            <div class="flex">
              {{$t('Video[3][1]')}}
              <div style="display:flex;align-items:center">
                <van-button v-if="UserInfo.is_key==1&&StatisticalData.today_s_o_num" color="var(--button-main)" round size="mini" style="margin-right: 15px" @click="submitAllVideo">{{$t('Video[10]')}}</van-button>
                <b>{{StatisticalData.today_s_o_num}}</b>
              </div>
            </div>
          </div>
          <div class="video">
            <a v-if="playStart" class="count-down" href="javascript:;" @click="countDown==0?closeVideo():false">{{countDown==0?$t('Video[7]'):countDown}}</a>
            <video-player  
              class="vjs-custom-skin"
              ref="videoPlayer"
              :playsinline="true"
              x5-playsinline
              webkit-playsinline
              :options="playerOptions"
              @ready="playerReadied"
              @play="onPlayerPlay($event)"
              @pause="onPlayerPause($event)"
              @ended="onPlayerEnded($event)"
              @loadeddata="onPlayerLoadeddata($event)"
            />
            <van-popup class="down-popup" v-model="showDown" position="right" :overlay="false">
              <a href="javascript:;" @click="clickDown">
                <img :src="`./static/images/${$i18n.locale}/video-down.png`" width="100%" height="100%">
              </a>
            </van-popup>
          </div>
        </div>
        <div v-if="UserInfo" class="btn">
          <van-button color="var(--button-main)" round block :disabled="playStart" style="font-size:16px" @click="openVideo(false)">{{$t('Video[4]')}}</van-button>
          <van-button v-if="InitData.setting.is_share==1&&StatisticalData.today_s_o_num==0" color="var(--button-main)" round block style="margin-top: 10px" @click="$refs.shareDom.showSheet=true,shareType='income',shareDan='video',getShareOptions('income')">{{$t('Share[7]')}}({{$t('Share[13]')}}{{InitData.currency}}{{incomeShare.all_reward}})</van-button>
          <!-- <van-button color="var(--button-main)" plain round block style="font-size:16px;margin-top: 10px" @click="openVideo(true)">{{$t('Video[6]')}}</van-button> -->
        </div>
        <div v-else class="btn">
          <van-button color="var(--button-main)" plain round block style="font-size:16px" to="/login">{{$t('Video[5]')}}</van-button>
        </div>
      </div>
      <van-loading v-else size="60px" vertical style="margin-top: 20%">{{$t('task.show[13]')}}</van-loading>
    </div>
    <Footer />
    <van-popup v-model="showVideo" close-on-popstate :close-on-click-overlay="false" :overlay-style="{'background-color':'rgba(0,0,0,.9)'}" style="height:100%;width:100%;background:transparent" @opened="openedVideo" @close="closeVideo">
      <a v-if="countDown==0" class="count-down" href="javascript:;" @click="showVideo=false">{{$t('Video[7]')}}</a>
      <a v-else class="count-down" href="javascript:;">{{countDown}}</a>
      <video-player  
        class="vjs-custom-skin"
        ref="fullPlayer"
        :playsinline="true"
        :options="fullOptions"
        @play="onPlayerPlay($event)"
        @pause="onPlayerPause($event)"
        @ended="onPlayerEnded($event)"
        @loadeddata="onPlayerLoadeddata($event)"
      />
    </van-popup>
    <ShareSheet ref="shareDom" :shareType="shareType" :shareDan="shareDan" :shareOptions="shareOptions" />
    <van-dialog v-model="showBind" :title="$t('dialog[0]')" show-cancel-button :confirm-button-text="$t('dialog[1]')" :before-close="onSubmitBind">
      <div style="padding: 16px;text-align:center;font-size: 13px">
        <h4>{{bindMsg}}</h4>
        <van-form ref="bindForm">
          <van-field 
            v-model="bindPhone"
            name="phone"
            type="digit"
            :placeholder="$t('UserInfo[2][1]')"
            :rules="[{required: true}]"
            style="border:1px #ddd solid;margin-top: 15px;border-radius: 5px;" 
          />
        </van-form>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import ShareSheet from '../share/action.vue'
import videojs from 'video.js'
export default {
  name: 'Video',
  components: {
    ShareSheet
  },
  props: ['tabsActive'],
  data() {
    return {
      taskInfo: '',
      playerOptions: {
        controls: false,
        aspectRatio: '16:9',
        sources: [{
          type: 'video/mp4',
          src: ''
        }]
      },
      fullOptions: {
        controls: false,
        sources: [{
          type: 'video/mp4',
          src: ''
        }]
      },
      showVideo: false,
      countDown: 0,
      intervalTimer: null,
      orderId: '',
      isSubmit: false,
      playStart: false,
      showDown: false,
      rateVal: 5,
      docTitle: document.title,
      downTimer: null,
      isSubmitTask: false,
      onlineNum: 0,
      onlineTimer: null,
      shareType: 'vip',
      shareDan: '',
      shareOptions: [],
      vipShare: '',
      incomeShare: '',
      showBind: false,
      bindMsg: '',
      bindPhone: ''
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
    fullPlayer() {
      return this.$refs.fullPlayer.player
    },
    gradeInfo() {
      if(this.$store.state.UserInfo){
        return this.InitData.UserGradeList.find(item=>item.grade==this.$store.state.UserInfo.vip_level)
      }else{
        return {
          name: this.$t('Video[0][0]'),
          commission: 0
        }
      }
    }
  },
  watch: {

  },
  created() {
    this.$Model.GetStatisticsInfo()
    this.getListData()
    if(this.$store.state.InitData.setting.is_online==1){
      this.getOnline()
      this.onlineTimer = setInterval(()=>{
        this.getOnline()
      },this.$store.state.InitData.setting.second?(this.$store.state.InitData.setting.second*1000):10000)
    }
    this.$Model.GetShareList({shareType:'vip',dan:''},data=>{
      this.vipShare = data
    })
    this.$Model.GetShareList({shareType:'income',dan:'video'},data=>{
      this.incomeShare = data
    })
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    clearInterval(this.intervalTimer)
    clearInterval(this.onlineTimer)
    clearTimeout(this.downTimer)
  },
  methods: {
    onSubmitBind(action, done) {
      if(action=='confirm'){
        this.$refs.bindForm.validate('phone').then(()=>{
          this.$Model.SetUserInfo({phone: this.bindPhone},data=>{
            if(data.code==1){
              done()
            }else{
              done(false)
            }
          })
        }).catch(err=>{
          done(false)
        })
      }else{
        done()
      }
    },
    openUrl(data){
      if(data.url){
        if(data.urltype=='w'){
          this.$Util.OpenUrl(data.url)
        }else{
          this.$router.push(data.url)
        }
      }else{
        return false
      }
    },
    getShareOptions(type) {
      if(type=='vip'){
        this.shareOptions = this.vipShare.sharelist.flatMap(item=>[{
          name: item.title, 
          icon: this.$store.state.InitData.setting.up_url+item.cover_img, 
          id: item.id,
          is_share: item.is_share,
          reward: item.reward,
          status_dec: item.status_dec
        }])
      }
      if(type=='income'){
        this.shareOptions = this.incomeShare.sharelist.flatMap(item=>[{
          name: item.title, 
          icon: this.$store.state.InitData.setting.up_url+item.cover_img, 
          id: item.id,
          is_share: item.is_share,
          reward: item.reward,
          status_dec: item.status_dec
        }])
      }
    },
    submitAllVideo() {
      this.$Model.SubmitAllVideo({type: 'video'},data=>{
        if(data.code==1){
          this.getListData()
          this.$Model.GetShareList({shareType:'income',dan:'video'},data=>{
            this.incomeShare = data
          })
        }
      })
    },
    getOnline(){
      this.$Model.GetOnline(data=>{
        this.onlineNum = data.online
      })
    },
    openVip() {
      if(this.$store.state.InitData.setting.vip_open!=1){
        this.$Dialog.Toast(this.$t('dialog[11]'))
      }else{
        this.$router.push('/vip')
      }
    },
    clickDown() {
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        this.$Util.OpenUrl(this.taskInfo.info[0].iosdown)
      }else{
        this.$Util.OpenUrl(this.taskInfo.info[0].appdown)
      }
    },
    getCountDown(){
      this.intervalTimer = setInterval(()=>{
        if(this.countDown>0){
          this.countDown --
        }else{
          if(!this.isSubmitTask){
            this.$Model.SubmitTask({order_id: this.orderId,status: 3},data=>{
              this.isSubmitTask = true
            })
          }
          clearInterval(this.intervalTimer)
        }
      },1000)
    },
    closeVideo() {
      this.player.pause()
    },
    openVideo(full) {
      if(this.InitData.setting.video_phone==1&&!this.UserInfo.phone){
        this.$Dialog.Alert(this.$t('Video[11]'),()=>{
          this.$router.push('/user/set/phone')
        })
        return
      }
      if(this.InitData.setting.video_mail==1&&!this.UserInfo.mail){
        this.$Dialog.Alert(this.$t('Video[12]'),()=>{
          this.$router.push('/user/set/mail')
        })
        return
      }
      if(!this.isSubmit&&!this.playStart){
        this.isSubmit = true
        // if(this.taskInfo.my_s_day_number==0){
        //   this.isSubmit = false
        //   // if(full){
        //   //   this.showVideo = true
        //   // }else{
        //   //   this.player.play()
        //   // }
        // }else{
          
        // }
        this.$Model.ReceiveTask(this.taskInfo.info[0].task_id,data=>{
          this.isSubmit = false
          if(data.code==1){
            this.orderId = data.order_id
            if(full){
              this.showVideo = true
            }else{
              this.player.play()
            }
          }else if(data.code==2){
            this.bindMsg = data.code_dec
            this.showBind = true
          }else{
            this.orderId = ''
          }
        })
      }
    },
    openedVideo() {
      this.fullPlayer.play()
    },
    getListData(player) {
      clearInterval(this.intervalTimer)
      clearTimeout(this.downTimer)
      this.countDown = 0
      this.showDown = false
      this.playerOptions.sources[0].src = this.taskInfo.company_video
      this.fullOptions.sources[0].src = this.taskInfo.company_video
      this.$Model.GetTaskList({task_level: this.$store.state.UserInfo.vip_level},data=>{
        if(data.code==1){
          this.taskInfo = data
          if(data.my_s_day_number==0){
            this.playerOptions.sources[0].src = this.taskInfo.company_video
            this.fullOptions.sources[0].src = this.taskInfo.company_video
            this.$Model.GetShareList({shareType:'income',dan:'video'},data=>{
              this.incomeShare = data
            })
          }else{
            this.playerOptions.sources[0].src = this.taskInfo.info[0].link_info
            this.fullOptions.sources[0].src = this.taskInfo.info[0].link_info
            this.countDown = this.taskInfo.info[0].task_second
          }
        }
        if(player){
          player.currentTime(0)
          player.trigger('loadstart')
        }
      })
    },
    playerReadied(player) {
      console.log('player readied',player)
      const BigPlayButton = videojs.getComponent('BigPlayButton')
      videojs.registerComponent('BigPlayButton', videojs.extend(BigPlayButton, {
        handleClick: (event)=>{
          if(this.$store.state.UserInfo){
            this.openVideo(false)
          }else{
            this.$router.push('/login')
          }
        }
      }))
      player.addChild('BigPlayButton');
    },
    onPlayerPlay(player) {
      console.log('player play!', player)
      if(this.countDown){
        this.playStart = true
        this.getCountDown()
      }
      if(this.taskInfo.info[0].isdown==1){
        this.downTimer = setTimeout(()=>{
          this.showDown = true
        },this.taskInfo.info[0].downtime*1000)
      }
    },
    onPlayerPause(player) {
      console.log('player pause!', player)
      this.playStart = false
      if(!this.isSubmitTask){
        this.$Model.SubmitTask({order_id: this.orderId,status: 3},data=>{
          this.isSubmitTask = false
        })
      }else{
        this.isSubmitTask = false
      }
      this.getListData(player)
    },
    onPlayerEnded(player) {
      console.log('player ended!', player)
      this.playStart = false
    },
    onPlayerLoadeddata(player) {
      console.log('loadeddata')
    }
  }
}
</script>
<style scoped>
.box-bg {
  background: linear-gradient(#efe6e3,#fff);
}
.user-grade {
  margin: 10px 20px;
  color: #fff;
  line-height: 1;
  position: relative;
}
.user-grade .bg{
  background-image: url('../../../public/static/images/default/task_bg.png'),linear-gradient(to right,#f83a3a,#fba030);
  background-repeat: no-repeat;
  background-size: 100%;
  padding: 25px 15px;
  border-radius: 10px 10px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
}
.user-grade .left{
  font-size: 24px;
}
.user-grade .left p{
  font-size: 12px;
  margin-top: 8px;
}
.user-grade .right{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.user-grade .line{
  height: 6px;
  background-color: #d1d1d1;
  border-radius: 10px;
  position: absolute;
  left: -5px;
  right: -5px;
  bottom: -2px;
}
.van-cell-group__title{
  font-size: 15px;
  font-weight: 600;
}
.income .van-cell__title{
  font-size: 30px;
  color: var(--color-important);
}
.income .van-cell__title small{
  font-size: 12px;
  color: var(--color-main);
  margin-left: 5px;
}
.task-item{
  margin: 15px;
  line-height: 1;
}
.task-item .info{
  background-color: var(--background-box);
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 15px;
}
.task-item .progress{
  margin-bottom: 15px;
}
.task-item .progress .flex{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.task-item .progress .flex b{
  font-size: 15px;
}
.task-item .van-progress{
  margin: 8px 0;
}
.count-down{
  position: absolute;
  right: 10px;
  top: 10px;
  background-color: rgba(0, 0, 0, .5);
  border-radius: 50px;
  min-width: 30px;
  height: 30px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border: 1px #fff solid;
  color: #fff;
  z-index: 3000;
}
.video{
  position: relative;
}
.down-btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 99;
}
.down-popup {
  width: 25%;
  right: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, .2);
  border-radius: 5px;
  text-align: center;
  font-size: 12px;
  line-height: 1;
  height: 60%;
  position: absolute;
  overflow: hidden;
}
.down-popup>a{
  display: block;
  height: 100%;
}
.down-popup h4{
  margin: 10px 0;
  font-weight: 600;
  font-size: 12px;
}
.down-popup .rate{
  color: #ffd21e;
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 12px;
}
.down-popup .rate span{
  margin-right: 3px;
}
.van-cell-group__title{
  display: flex;
  justify-content: space-between;
}
.online-user{
  color: var(--color-active);
  font-size: 12px;
  font-weight: 400;
}
.box-shadow {
  height: 5px;
  box-shadow: 0 4px 10px #ea6b5d;
  margin: -15px 25px 15px;
  position: relative;
  z-index: 2;
}
</style>